<template>
  <div class="main-box">
    <img src="../assets/banner.png" alt="" class="banner-img" />
    <List
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
      class="list-box"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list-item"
        @click="toDetail(item)"
      >
        <div class="img-box">
          <img :src="item.cover" alt="" />
        </div>
        <div>
          <div class="title">{{ item.name }}</div>
          <p>来源：{{ item.company }}</p>
        </div>
      </div>
    </List>
  </div>
</template>

<script >
import { List, Toast, Popup, Dialog, Picker } from 'vant';
const baseUrl = '20251031YUCHAO';
import { getList } from '../api/index';

export default {
  components: {
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.loading = true;
      this.finished = false;
      getList({
        page: this.page,
        workType: 1,
      }).then((res) => {
        this.page = this.page + 1;
        if (res.code === 200) {
          if (!res.data || res.data.length === 0) {
            this.finished = true;
          } else {
            this.list = [...this.list, ...res.data];
          }

          console.log(res, this.list);
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    toDetail(item) {
      this.$router.push({
        path: `/${baseUrl}/ipDetail`,
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main-box {
  min-height: 100vh;
  background: #f7f9f4;
}
.banner-img {
  width: 100%;
  margin-bottom: 15px;
}
.list-box {
  padding: 0 13px;
}
.list-item {
  display: inline-block;
  width: 168px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  padding: 4px;
  box-sizing: border-box;
  margin-bottom: 17px;
  margin-right: 13px;
  padding-bottom: 11px;
  &:nth-child(2n) {
    margin-right: 0;
  }
  .img-box {
    width: 160px;
    height: 160px;
    background: #e8e8e8;
    border-radius: 5px 5px 5px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .title {
    font-size: 15px;
    color: #000000;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 8px;
  }
  p {
    font-size: 14px;
    color: #666666;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 39px;
  }
}
</style>
